import { EmployeeDto, getEmptyEmployeeDto } from '../user/userTypes';
import { emptyQuestionCatalogue, QuestionCatalogueDto } from '../questionCatalogue/qustionCatalogueTypes';
import { AnsweredCatalogueDto } from '../answeredCatalogueTypes';

export interface QuestionnaireRequest {
  title: string,
  description: string,
  startDate: string,
  endDate: string,
  anonymous: boolean,
  appraisee: EmployeeDto,
  appraisers: EmployeeDto[],
  catalogue: QuestionCatalogueDto
}

export interface BaseQuestionnaire extends QuestionnaireRequest{
  id: number,
}

export interface QuestionnaireDto extends BaseQuestionnaire {
  answeredCatalogue: AnsweredCatalogueDto[]
}

export function emptyQuestionnaireRequest(): QuestionnaireRequest {
  return {
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    anonymous: false,
    appraisee: getEmptyEmployeeDto(),
    appraisers: [],
    catalogue: emptyQuestionCatalogue()
  }
}

export function emptyQuestionnaire(): QuestionnaireDto {
  return {
    id: 0,
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    anonymous: false,
    appraisee: getEmptyEmployeeDto(),
    appraisers: [],
    catalogue: emptyQuestionCatalogue(),
    answeredCatalogue: []
  }
}
